import {
	GET_CATEGORIES_FAIL,
	GET_CATEGORIES_SUCCESS,
	GET_REPORTS_FAIL,
	GET_REPORTS_SUCCESS,
	SET_LOADING_SUCCESS,
	GENERATE_CSV_SUCCESS,
	GENERATE_CSV_FAIL,
} from './types';

const initialState = {
	categories: [],
	reports: [],
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_CATEGORIES_SUCCESS:
		case GET_CATEGORIES_FAIL:
			return {
				...state,
				categories: payload,
				loading: false,
			};
		case GET_REPORTS_SUCCESS:
		case GET_REPORTS_FAIL:
			return {
				...state,
				reports: payload,
				loading: false,
			};
		case SET_LOADING_SUCCESS:
			return {
				...state,
				loading: payload,
			};

		default:
			return state;
	}
}
